export const eventToRouteMap = {
  pancard_verification: "/pan-details",
  personal_details: "/pan-details",
  selfie_upload: "/upload-picture",
  register_now: "/register-now",
  employment_details: "/other-information",
  initiate_account_aggregator: "/account-aggregator",
  check_account_aggregator: "/account-aggregator-redirect",
  banking_details: "/banking-details",
  bank_statement_upload: "/bank-statement-upload",
  initiate_ekyc: "/e-kyc",
  check_ekyc_status: "/verify-digilocker-ekyc",
  thank_you: "/congratulations",
};

export const LEAD_STAGE = {
  PENDING_LEAD: "PENDING_LEAD",
  PARTIAL_REGISTERED_LEAD: "PARTIAL_REGISTERED_LEAD",
  COMPLETE_REGISTRATION: "COMPLETE_REGISTRATION",

  ADD_EMPLOYEMENT: "ADD_EMPLOYEMENT",
  PENDING_EMPLOYEMENT: "PENDING_EMPLOYEMENT_WITH_SELF_EMPLOYEED",

  SEND_EMAIL_OTP: "SEND_EMAIL_OTP", // not helpful
  VERIFY_EMAIL_OTP: "VERIFY_EMAIL_OTP",

  AA_FAILED: "AA_FAILED",

  BRE_APPROVED: "BRE_APPROVED",
  BRE_REJECT: "BRE_REJECT",

  LOAN_REQUESTED: "LOAN_REQUESTED",
  REFERENCE_ADDED: "REFERENCE_ADDED",

  SEND_AADHAAR_OTP: "SEND_AADHAAR_OTP", //not helpful
  VERIFY_AADHAAR_KYC: "VERIFY_AADHAAR_KYC",
  KYC_DOC_UPLOADED: "KYC_DOC_UPLOADED",
  REJECT_AADHAR_KYC: "REJECT_AADHAR_KYC",

  SANCTION_COMPLETED: "SANCTION_COMPLETED",
  SANCTION_PENDING: "SANCTION_PENDING",

  DISBURSED: "DISBURSED",
  DISBURSAL_FAILED: "DISBURSAL_FAILED",

  APPLY_RELOAN: "APPLY_RELOAN",

  MANUALLY_REJECT: "MANUALLY_REJECT",
  HARD_REJECT: "HARD_REJECT",
  MANUALLY_APPROVE: "MANUALLY_APPROVE",
  BRE_MANUALLY_REJECT: "BRE_MANUALLY_REJECT",
  KYC_MANUALLY_REJECT: "KYC_MANUALLY_REJECT",
  CLOSED: "CLOSED",
  PARTIAL_PAYMENT: "PARTIAL_PAYMENT",
  DISBURSAL_INI: "DISBURSAL_INI"
};

export const leadStageToRouteMap = {
  PARTIAL_REGISTERED_LEAD: "/apply/partial-details",
  COMPLETE_REGISTRATION: "/apply/employment-status",
  ADD_EMPLOYEMENT: "/apply/email",
  VERIFY_EMAIL_OTP: "/apply/account-aggregator",

  BRE_APPROVED: "/apply/loan-amount",
  MANUALLY_APPROVE: "/apply/loan-amount",

  AA_FAILED: "/apply/upload-bank-statement",

  LOAN_REQUESTED: "/apply/pre-e-sign",
  SEND_AADHAAR_OTP: "/apply/pre-e-sign",
  REFERENCE_ADDED: "/apply/e-sign",
  VERIFY_AADHAAR_KYC: "/apply/kyc-documents",
  KYC_DOC_UPLOADED: "/apply/references",
  SANCTION_COMPLETED: "/apply/disbursal",

  CLOSED: "/dashboard",
  DISBURSED: "/dashboard",
  PARTIAL_PAYMENT: "/dashboard",

  BRE_REJECT: "/apply/thank-you",
  DISBURSAL_FAILED: "/apply/thank-you",
  PENDING_EMPLOYEMENT_WITH_SELF_EMPLOYEED: "/apply/thank-you",
  REJECT_AADHAR_KYC: "/apply/thank-you",

  HARD_REJECT: "/apply/rejected",
  BRE_MANUALLY_REJECT: "/apply/rejected",
  KYC_MANUALLY_REJECT: "/apply/rejected",
  MANUALLY_REJECT: "/apply/rejected",
};

// Automation Node (Dhanrishi flow) routes - same lead stages, under /apply/
export const automationNodeLeadStageToRouteMap = {
  PARTIAL_REGISTERED_LEAD: "/apply/partial-details",
  COMPLETE_REGISTRATION: "/apply/employment-status",
  ADD_EMPLOYEMENT: "/apply/email",
  VERIFY_EMAIL_OTP: "/apply/account-aggregator",
  BRE_APPROVED: "/apply/loan-amount",
  MANUALLY_APPROVE: "/apply/loan-amount",
  AA_FAILED: "/apply/upload-bank-statement",
  LOAN_REQUESTED: "/apply/pre-e-sign",
  SEND_AADHAAR_OTP: "/apply/pre-e-sign",
  REFERENCE_ADDED: "/apply/e-sign",
  VERIFY_AADHAAR_KYC: "/apply/kyc-documents",
  KYC_DOC_UPLOADED: "/apply/references",
  SANCTION_COMPLETED: "/apply/disbursal",
  CLOSED: "/dashboard",
  DISBURSED: "/dashboard",
  PARTIAL_PAYMENT: "/dashboard",
  BRE_REJECT: "/apply/thank-you",
  DISBURSAL_FAILED: "/apply/thank-you",
  PENDING_EMPLOYEMENT_WITH_SELF_EMPLOYEED: "/apply/thank-you",
  REJECT_AADHAR_KYC: "/apply/thank-you",
  HARD_REJECT: "/apply/rejected",
  BRE_MANUALLY_REJECT: "/apply/rejected",
  KYC_MANUALLY_REJECT: "/apply/rejected",
  MANUALLY_REJECT: "/apply/rejected",
};
